'use client';

import classNames from 'classnames';
import React from 'react';
import { Breadcrumb } from '../../../../paths';
import styles from './ArticleBreadcrumbs.module.scss';

const ArticleBreadcrumbs = ({ items, className }: { items: Breadcrumb[]; className?: string }) => {
  const removeAsterisks = (text: string) => text.replace(/\*\*(.*?)\*\*/g, '$1');

  return (
    <div className={classNames(styles.breadcrumbs, className)}>
      {items.map((item, index) => {
        const isCurrentItem = index === items.length - 1;
        const Wrapper = isCurrentItem ? 'div' : 'a';

        return (
          <React.Fragment key={item.path}>
            <Wrapper
              {...(isCurrentItem ? {} : { href: item.path })}
              className={classNames(styles.breadcrumb, {
                [styles.active]: isCurrentItem,
                [styles.lastItem]: isCurrentItem,
              })}
            >
              {removeAsterisks(item.name || '')}
            </Wrapper>
            <svg className={styles.arrowIcon}>
              <use
                href='/media/angle_down.svg#angleDown'
                xlinkHref='/media/angle_down.svg#angleDown'
              />
            </svg>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ArticleBreadcrumbs;
